import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/probe/layer.probe.mutation.gql"
import type {
  LayerProbeMutation,
  LayerProbeMutationVariables,
} from "@/v2-backoffice-client/layer/probe/__types__/layer.probe.mutation"

type Options = MutationHookOptions<
  LayerProbeMutation,
  LayerProbeMutationVariables
>

export function useLayerProbeMutation(options?: Options) {
  return useMutation<LayerProbeMutation, LayerProbeMutationVariables>(
    mutation,
    options,
  )
}
